export default __webpack_public_path__ + "static/media/shared-leadership.f60a21c6.svg";